<template>
  <div
    class="embed"
    :class="{ 'embed--video': isAllowed }"
    v-if="vendor && source"
  >
    <template v-if="isAllowed">
      <iframe
        sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"
        class="embed__iframe"
        :src="source"
        :allow="vendor?.attribute?.allow"
        :allowfullscreen="vendor?.attribute?.allowfullscreen"
      />
    </template>

    <slot
      name="placeholder"
      v-else
    >
      <app-consent-placeholder />
    </slot>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useConsent } from '@/vendors/consent'
import { useVendors } from '@/composables/app/useVendors'

const AppConsentPlaceholder = defineAsyncComponent(() => import('&/atoms/AppConsentPlaceholder'))

const { src, params } = defineProps({
  src: String,
  params: { type: Object, default: () => ({}) }
})

const { isVendorAllowed } = useConsent()
const { getVendorByUrl, getVendorUrl } = useVendors()

const vendor = getVendorByUrl(src)
const source = getVendorUrl({ src, params })

const isAllowed = computed(() => isVendorAllowed(vendor?.name))
</script>

<style lang="scss" scoped>
.embed {
  overflow: hidden;
  position: relative;
  width: 100%;

  &--video {
    height: 0;
    padding-bottom: 56.25%;
  }

  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
